var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2996 7.28679C32.3224 7.60658 32.3224 7.92643 32.3224 8.24621C32.3224 18 24.8986 29.2387 11.33 29.2387C7.14975 29.2387 3.26652 28.0279 0 25.9265C0.593932 25.995 1.16494 26.0178 1.78173 26.0178C5.23092 26.0178 8.4061 24.8529 10.9417 22.8656C7.69798 22.797 4.97969 20.6727 4.04313 17.7488C4.50002 17.8173 4.95684 17.863 5.43658 17.863C6.099 17.863 6.76149 17.7716 7.3782 17.6117C3.99749 16.9264 1.46187 13.9569 1.46187 10.3706V10.2792C2.44407 10.8275 3.5863 11.1701 4.79688 11.2157C2.80956 9.89083 1.50758 7.62943 1.50758 5.07103C1.50758 3.70049 1.87299 2.44414 2.51263 1.34768C6.14463 5.82485 11.6041 8.74867 17.7259 9.06852C17.6117 8.52029 17.5431 7.94928 17.5431 7.3782C17.5431 3.31215 20.8325 0 24.9213 0C27.0457 0 28.9644 0.890863 30.3122 2.32995C31.9797 2.01017 33.5786 1.39339 34.9949 0.548229C34.4467 2.26147 33.2817 3.70056 31.7513 4.61421C33.2361 4.45438 34.6752 4.04313 36 3.47212C34.9951 4.93399 33.7387 6.23597 32.2996 7.28679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.02218f1a8c84fa898f5a3f07f2d92b87.svg";
export { ForwardRef as ReactComponent };